import React from "react";
import "./ProductCard.css";

function ProductCard({ product }) {
  return (
    <div className="product-card">
      <img src={product.image} alt={product.name} className="product-image" />
      <h3>{product.name}</h3>
      <a
        href={product.amazonLink}
        target="_blank"
        rel="noopener noreferrer"
        className="amazon-link-button"
      >
        Buy Now
      </a>
    </div>
  );
}

export default ProductCard;
